<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fLi0Dw/images/9781439667415.jpg?1684514560591" alt="This image is the cover for the book Grand Central Terminal and Penn Station, Images of Rail"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Grand Central Terminal and Penn Station, Images of Rail
      </h1>
      <p class="bookDescription body article font2">
        <p>Opened in 1913, Grand Central Terminal is a world-famous landmark building with a magnificent 48-foot-high, 1,500-ton statuary group on top of the main facade. Designed by sculptor Jules-Felix Coutan, a 13-foot-wide Tiffany clock serves as the centerpiece. The figure above the clock is Mercury, with Hercules to the left and Minerva to the right. In the late 1990s, a historic restoration was performed on the terminal after which two cast-iron eagle statues were placed over entrances at Lexington Avenue and Forty-Second Street/Vanderbilt Avenue. These eagles were from the 1898 Grand Central Station building that was demolished in 1910 to make room for the construction of the new Grand Central Terminal structure. Penn Station, which opened in 1910, covered two full city blocks and had statuary groups, designed by sculptor Adolph Weinman, on all four sides of the building. After Penn Station was demolished in the mid-1960s, the statuary was dispersed throughout various locations, mainly in the Northeast.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David D. Morrison, Lorraine B. Diehl
      </h2>
      
      <p class="authorDescription body article">David D. Morrison is a retired Long Island Rail Road branch line manager and railroad historian. Author of six books in Arcadia Publishing's Images of Rail series, he has researched the statuary and sculptures of Grand Central Terminal and Penn Station over the past 30 years. He was the catalyst for the placement of two cast-iron eagles that are at Grand Central Terminal today, and his research resulted in the Smithsonian Institution modifying a plaque at the National Zoo.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?68f1441d